<div
  class="mb-2"
  [ngClass]="
    baseService.isMobile
      ? 'd-flex flex-column gap-2 align-items-center'
      : 'd-flex flex-row justify-content-between gap-1'
  "
>
  <ng-container *ngTemplateOutlet="baseService.isMobile ? Dropdown : Statuses"></ng-container>
  <ng-container *ngTemplateOutlet="baseService.isMobile ? Statuses : Dropdown"></ng-container>
  <ng-template #Statuses>
    @if (filterStatuses?.length) {
      <div class="mt-2 d-flex gap-2 flex-wrap" [ngClass]="{ 'justify-content-center': baseService.isMobile }">
        @for (item of filterStatuses; track item) {
          <h5 class="text-black">
            <div
              class="badge btn-static click-css"
              [ngStyle]="{ '--color': item.active ? item.color : '#cccccc' }"
              (click)="onFilterChange(item)"
            >
              {{ item.name | translate }}
            </div>
          </h5>
        }
      </div>
    }
  </ng-template>
  <ng-template #Dropdown>
    <app-dropdown
      class="account-box"
      [ngClass]="{ 'w-100': baseService.isMobile }"
      [items]="items || []"
      [input]="currentChannelId || {}"
      [bindValue]="'id'"
      (onValueChange)="onValueChange($event)"
      [closeOnSelect]="true"
      [searchable]="true"
      placeholder="{{ 'channels' | translate }}"
    ></app-dropdown>
  </ng-template>
</div>
@if (isLoader) {
  <div class="d-flex justify-content-center">
    <app-loader size="small"></app-loader>
  </div>
} @else {
  @if (dataSource$ | async; as dataSource) {
    <div>
      @if (dataSource.items?.length) {
        <table-pagination
          [hidePageSize]="true"
          [length]="dataSource.length"
          [pageIndex]="dataSource.pageIndex"
          [pageSize]="dataSource.pageSize"
          dropdownPosition="bottom"
          (page)="onPaginationChange($event)"
          class="mat-paginator-sticky"
        >
        </table-pagination>
        <div class="d-flex flex-column gap-3 text-black">
          @for (item of dataSource.items; track item) {
            <mat-card [appPhotoGalleryGroup]="{ clickMode: 'single' }" class="gap-1 shadow-sm d-flex flex-column p-2">
              <div
                class="d-flex gap-1 text-center"
                [ngClass]="{ 'flex-column': baseService.isMobile, 'flex-row': !baseService.isMobile }"
              >
                <div class="m-1">
                  @if (item.ad.photo) {
                    <img
                      [appPhotoGallery]="{ url: item.ad.photo.split(';s=')[0], mimeType: 'image/png' }"
                      [src]="item.ad.photo.split(';s=')[0]"
                      [ngStyle]="{ 'max-width': baseService.isMobile ? '100%' : '200px' }"
                      class="img-delivery cursor-pointer"
                    />
                  }
                  @if (!item.ad.photo) {
                    <img
                      src="assets/svgs/special/thumbnail_delivery.svg"
                      [ngStyle]="{ 'max-width': baseService.isMobile ? '100%' : '200px' }"
                      class="img-delivery"
                    />
                  }
                </div>
                <div class="w-100 mt-2 mb-2 gap-1">
                  <div
                    class="d-flex justify-content-between gap-2 m-1"
                    [ngClass]="{ 'flex-column': baseService.isMobile, 'flex-row': !baseService.isMobile }"
                  >
                    <mat-card-title
                      [ngClass]="{ 'fs-6 text-center': baseService.isMobile, 'fs-5 text-start': !baseService.isMobile }"
                    >
                      <a class="title" [href]="item.ad.url" target="_blank">
                        {{ item.ad.title }}
                      </a>
                    </mat-card-title>
                    <mat-card-title
                      class="fw-semibold"
                      [ngClass]="{ 'fs-6': baseService.isMobile, 'fs-5': !baseService.isMobile }"
                    >
                      {{ item.cost?.sellerReceives / 100 }} грн.
                    </mat-card-title>
                  </div>
                  @if (baseService.isMobile) {
                  } @else {
                    <div
                      class="d-flex justify-content-between align-items-center m-1"
                      [ngClass]="{ 'flex-column gap-3': baseService.isMobile, 'flex-row gap-2': !baseService.isMobile }"
                    >
                      <div
                        class="text-center p-1 h-100"
                        style="border-radius: 4px; font-size: 0.8rem; font-weight: 500; color: white"
                        [ngStyle]="{ 'background-color': getStatusColor(item.statusShort) }"
                      >
                        {{ getStatus(item) }}
                      </div>
                      <div
                        class="d-flex flex-column gap-1"
                        style="font-size: 0.8rem"
                        [ngClass]="{ 'text-center': baseService.isMobile, 'text-start': !baseService.isMobile }"
                      >
                        @if (item.package.cheque?.number) {
                          <div class="delivery-other-text">
                            {{ 'olx.delivery.other.express_waybill' | translate }}
                          </div>
                        }
                        @if (!item.package.cheque?.number) {
                          <div class="delivery-other-text">
                            {{ 'olx.delivery.other.delivery_service' | translate }}
                          </div>
                        }
                        <div class="d-flex flex-row gap-2 align-items-center">
                          @if (item.recipient.shippingMethod === 'NOVAPOSHTA') {
                            <img src="assets/svgs/integrations/nova_poshta.svg" class="img-poshta" />
                          }
                          @if (item.recipient.shippingMethod === 'UKRPOSHTA') {
                            <img src="assets/svgs/integrations/ukr_poshta_icon.svg" class="img-poshta" />
                          }
                          @if (item.recipient.shippingMethod === 'MEEST') {
                            <img src="assets/svgs/integrations/meest.svg" class="img-poshta" />
                          }
                          @if (item.package.cheque?.number) {
                            <a target="_blank" [href]="item._links.packageTracking.href">
                              {{ item.package.cheque.number }}
                            </a>
                          }
                          @if (!item.package.cheque?.number && item?.recipient?.shippingMethod === 'NOVAPOSHTA') {
                            <div>
                              {{
                                ('olx.delivery.other.to_department' | translate) +
                                  ('olx.delivery.other.nova_poshta' | translate)
                              }}
                            </div>
                          }
                          @if (!item.package.cheque?.number && item?.recipient?.shippingMethod === 'UKRPOSHTA') {
                            <div>
                              {{
                                ('olx.delivery.other.to_department' | translate) +
                                  ('olx.delivery.other.ukrposhta' | translate)
                              }}
                            </div>
                          }
                          @if (!item.package.cheque?.number && item?.recipient?.shippingMethod === 'MEEST') {
                            <div>
                              {{
                                ('olx.delivery.other.to_department' | translate) +
                                  ('olx.delivery.other.meest' | translate)
                              }}
                            </div>
                          }
                        </div>
                      </div>
                      <div
                        class="fw-light d-flex flex-column gap-1"
                        [ngClass]="{ 'text-center': baseService.isMobile, 'text-end': !baseService.isMobile }"
                        style="font-size: 0.75rem"
                      >
                        <div>{{ item.createdAt | date: 'dd.MM.YY, HH:mm' }}</div>
                        <div>{{ 'olx.delivery.other.order_number' | translate }}: {{ item.orderId }}</div>
                      </div>
                    </div>
                  }
                </div>
              </div>
              @if (!baseService.isMobile) {
              } @else {
                <div
                  class="d-flex justify-content-between align-items-center m-1"
                  [ngClass]="{ 'flex-column gap-3': baseService.isMobile, 'flex-row gap-2': !baseService.isMobile }"
                >
                  <div
                    class="text-center p-1 h-100"
                    style="border-radius: 4px; font-size: 0.8rem; font-weight: 500; color: white"
                    [ngStyle]="{ 'background-color': getStatusColor(item.statusShort) }"
                  >
                    {{ getStatus(item) }}
                  </div>
                  <div
                    class="d-flex flex-column gap-1"
                    style="font-size: 0.8rem"
                    [ngClass]="{ 'text-center': baseService.isMobile, 'text-start': !baseService.isMobile }"
                  >
                    @if (item.package.cheque?.number) {
                      <div class="delivery-other-text">
                        {{ 'olx.delivery.other.express_waybill' | translate }}
                      </div>
                    }
                    @if (!item.package.cheque?.number) {
                      <div class="delivery-other-text">
                        {{ 'olx.delivery.other.delivery_service' | translate }}
                      </div>
                    }
                    <div class="d-flex flex-row gap-2 align-items-center">
                      @if (item.recipient.shippingMethod === 'NOVAPOSHTA') {
                        <img src="assets/svgs/integrations/nova_poshta.svg" class="img-poshta" />
                      }
                      @if (item.recipient.shippingMethod === 'UKRPOSHTA') {
                        <img src="assets/svgs/integrations/ukr_poshta_icon.svg" class="img-poshta" />
                      }
                      @if (item.recipient.shippingMethod === 'MEEST') {
                        <img src="assets/svgs/integrations/meest.svg" class="img-poshta" />
                      }
                      @if (item.package.cheque?.number) {
                        <a target="_blank" [href]="item._links.packageTracking.href">
                          {{ item.package.cheque.number }}
                        </a>
                      }
                      @if (!item.package.cheque?.number && item?.recipient?.shippingMethod === 'NOVAPOSHTA') {
                        <div>
                          {{
                            ('olx.delivery.other.to_department' | translate) +
                              ('olx.delivery.other.nova_poshta' | translate)
                          }}
                        </div>
                      }
                      @if (!item.package.cheque?.number && item?.recipient?.shippingMethod === 'UKRPOSHTA') {
                        <div>
                          {{
                            ('olx.delivery.other.to_department' | translate) +
                              ('olx.delivery.other.ukrposhta' | translate)
                          }}
                        </div>
                      }
                      @if (!item.package.cheque?.number && item?.recipient?.shippingMethod === 'MEEST') {
                        <div>
                          {{
                            ('olx.delivery.other.to_department' | translate) + ('olx.delivery.other.meest' | translate)
                          }}
                        </div>
                      }
                    </div>
                  </div>
                  <div
                    class="fw-light d-flex flex-column gap-1"
                    [ngClass]="{ 'text-center': baseService.isMobile, 'text-end': !baseService.isMobile }"
                    style="font-size: 0.75rem"
                  >
                    <div>{{ item.createdAt | date: 'dd.MM.YY, HH:mm' }}</div>
                    <div>{{ 'olx.delivery.other.order_number' | translate }}: {{ item.orderId }}</div>
                  </div>
                </div>
              }
            </mat-card>
          }
        </div>
        <table-pagination
          [hidePageSize]="true"
          [length]="dataSource.length"
          [pageIndex]="dataSource.pageIndex"
          [pageSize]="dataSource.pageSize"
          dropdownPosition="bottom"
          (page)="onPaginationChange($event)"
          class="mat-paginator-sticky"
        >
        </table-pagination>
      }
      @if (!dataSource.items?.length) {
        <div class="d-flex justify-content-center text-black">
          {{ 'nothing_found' | translate }}
        </div>
      }
    </div>
  }
}
